import { Box, Typography, Button, TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import { useContext, useEffect } from "react";
import { StyledForm } from "./Form.styled";
import { LanguageContext } from "../../globals/LanguageContext";
import { useProfile } from "../../stores/useProfile";
import { Author } from "../../models/Author";
import { FormProps } from "../../models/global/Types";

interface ContactInfoFormProps extends FormProps {
  contactInfo: Author;
}

export const ContactInfoForm = ({
  contactInfo,
  onSave,
}: ContactInfoFormProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Author>({});
  const { dictionary } = useContext(LanguageContext);

  const { user } = useProfile();

  useEffect(() => {
    if (!user) return;
  });

  const onSubmit = (data: Author) => {
    if (!user) return;

    onSave();
  };

  return (
    <StyledForm onSubmit={handleSubmit(onSubmit)}>
      <Box className="row">
        <Box className="column">
          <Typography variant="h4">
            {dictionary.contactinfoform.firstname}
          </Typography>
          <TextField
            {...register("firstName", {
              required: dictionary.errormessages.form_fieldrequired,
            })}
            error={!!errors.firstName}
            helperText={errors?.firstName?.message}
            InputLabelProps={{ shrink: true }}
            fullWidth
            value={contactInfo.firstName}
          />
        </Box>
        <Box className="column">
          <Typography variant="h4">
            {dictionary.contactinfoform.lastname}
          </Typography>
          <TextField
            {...register("lastName", {
              required: dictionary.errormessages.form_fieldrequired,
            })}
            error={!!errors.lastName}
            helperText={errors?.lastName?.message}
            InputLabelProps={{ shrink: true }}
            fullWidth
            value={contactInfo.lastName}
          />
        </Box>
      </Box>

      <Typography variant="h4">{dictionary.contactinfoform.email}</Typography>
      <TextField
        {...register("email", {
          required: dictionary.errormessages.form_fieldrequired,
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: dictionary.errormessages.form_wrongemail,
          },
        })}
        error={!!errors.email}
        helperText={errors?.email?.message}
        InputLabelProps={{ shrink: true }}
        fullWidth
        value={contactInfo.email}
      />
      <Typography variant="h4">{dictionary.contactinfoform.phone}</Typography>
      <TextField
        {...register("phone", {
          required: true,
          pattern: {
            value: /^(?:\+32|0)\d([\s]?\d{2}[\s.-]?){3}\d{2}$/i,
            message: dictionary.errormessages.form_wrongphonenr,
          },
        })}
        error={!!errors.phone}
        helperText={errors?.phone?.message}
        InputLabelProps={{ shrink: true }}
        value={contactInfo.phone}
      />
      <Typography variant="h4">{dictionary.contactinfoform.address}</Typography>
      <TextField
        {...register("address", {
          required: dictionary.errormessages.form_fieldrequired,
        })}
        error={!!errors.address}
        helperText={errors?.address?.message}
        InputLabelProps={{ shrink: true }}
        fullWidth
        value={contactInfo.address}
      />
      <Button type="submit">{dictionary.buttons.savebtn}</Button>
    </StyledForm>
  );
};
